import { Button } from "@tellescope/design-system";
import {
  FilterBlockEditor,
  MultiSelect,
  type MultiSelectOption,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@tellescope/ui";
import { type FreeformFieldOption, type FreeformFilterBlock } from "@tellescope/utils";
import { ListFilter } from "lucide-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export interface RelatedContactsFilterPopoverProps {
  filterBlock: FreeformFilterBlock;
  fieldOptions: FreeformFieldOption[];
  relationshipOptions: string[];
  onFilterChange: (block: FreeformFilterBlock) => void;
}

export const RelatedContactsFilterPopover = ({
  filterBlock,
  fieldOptions,
  relationshipOptions,
  onFilterChange,
}: RelatedContactsFilterPopoverProps) => {
  const { t } = useTranslation("contacts");

  const selectOptions = useMemo<MultiSelectOption[]>(
    () => relationshipOptions.map((type) => ({ label: type, value: type })),
    [relationshipOptions]
  );

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button iconOnly variant="ghost" size="sm" color="muted" hoverLabel={t("Filter related contacts")}>
          <ListFilter />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-2" align="end">
        <FilterBlockEditor
          block={filterBlock}
          fieldOptions={fieldOptions}
          onChange={onFilterChange}
          onRemove={() => onFilterChange({ ...filterBlock, filters: [] })}
          renderValueInput={({ filter, onChange }) => (
            <MultiSelect
              className="w-full bg-white text-xs font-light"
              options={selectOptions}
              value={Array.isArray(filter.value) ? filter.value : []}
              onValueChange={(value) => onChange({ ...filter, value })}
              placeholder={t("Select relationship")}
            />
          )}
        />
      </PopoverContent>
    </Popover>
  );
};
